// client/src/components/ImpersonationBanner.tsx
"use client";

import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { X, Eye } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function ImpersonationBanner() {
  const { impersonationSession, endImpersonation } = useAuth();
  const router = useRouter();

  if (!impersonationSession) return null;

  const handleExit = async () => {
    await endImpersonation();
    router.push('/admin/dashboard');
  };

  return (
    <div className="sticky top-0 z-50 bg-investments-500 text-white px-4 py-6 flex items-center justify-center gap-3 shadow-md">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span className="text-sm font-medium">
          Viewing as <span className="font-bold">{impersonationSession.targetEmail}</span>
        </span>
      </div>
      <button
        onClick={handleExit}
        className="inline-flex items-center gap-1 px-3 py-1 text-sm bg-white text-investments-600 font-semibold rounded hover:bg-investments-50 transition"
      >
        <X className="h-3 w-3" />
        Exit Impersonation
      </button>
    </div>
  );
}
